var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('brand-footer'),_vm._v(" "),_c('div',{staticClass:"copyright"},[_vm._v("\n            © "+_vm._s(_vm.year)+"\n            "),_c('a',{attrs:{"href":"http://fraysse.eu","target":"_blank"}},[_vm._v("Sébastien Fraysse")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }